import ApiService from '../api.service';

const fileService = {
    downloadFile: async payload => {
        try {
            const { files, guid, document } = payload;
            const formData = new FormData();
            files.forEach(file => {
                formData.append('file', file.file);
            });
            const response = await ApiService.post('docs/attachmentsLinkInsert', formData, { params: { guid, document }, showLoader: true });
            return response.data;
        } catch (e) {
            console.error(e);
        }
    },
    getFilesList: async payload => {
        try {
            const response = await ApiService.get('docs/getAttachments', { params: { guid: payload } });
            return response.data;
        } catch (e) {
            console.error(e);
        }
    },
    getFile: async payload => {
        try {
            const response = await ApiService.get('docs/getAttachment', { params: { iAttachmentLinkRid: payload } });
            return response.data;
        } catch (e) {
            console.error(e);
        }
    }
};

export default fileService;
